import script from "./UseLabOSSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./UseLabOSSection.vue?vue&type=script&setup=true&lang=ts"

import "./UseLabOSSection.vue?vue&type=style&index=0&id=079794b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079794b9"]])

export default __exports__